export const FETCH_QUESTIONS = 'FETCH_QUESTIONS';
export const NEW_PRIVATE_QUESTION = 'NEW_PRIVATE_QUESTION';
export const NEW_PUBLIC_QUESTION = 'NEW_PUBLIC_QUESTION';
export const DELETE_QUESTION = 'DELETE_QUESTION';
export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const QUESTION_ERROR = 'QUESTION_ERROR';
export const QUESTIONS_LOADING = 'QUESTIONS_LOADING';

export const USER_LOADING = 'USER_LOADING';
export const USER_LOADED = 'USER_LOADED';
export const USER_UPDATED = 'USER_UPDATED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const ADMIN_LOADED = 'ADMIN_LOADED';
export const ADMIN_FAIL = 'ADMIN_FAIL';
export const PUBLISHER_LOADED = 'PUBLISHER_LOADED';
export const PUBLISHER_FAIL = 'PUBLISHER_FAIL';
export const UPDATING_PASSWORD = 'UPDATING_PASSWORD';
export const UPDATED_PASSWORD = 'UPDATED_PASSWORD';

export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
